import { devices } from '@src/styles/theme';
import styled from 'styled-components';

const FourText = () => {
  return (
    <Container>
      <PcTitle>올해 피플을 통해 피를 나눈 사람은</PcTitle>
      <MbTitle>
        올해 피플을 통해
        <br /> 피를 나눈 사람은
      </MbTitle>
      <MarginWrap>
        <CountBox isInt={true}>4</CountBox>
        <Div>,</Div>
        <CountBox isInt={true}>3</CountBox>
        <CountBox isInt={true}>8</CountBox>
        <CountBox isInt={true}>2</CountBox>
        <CountBox isInt={false}>명</CountBox>
        이었고,
      </MarginWrap>
      <MarginWrap2>
        도움을 받은 환자 수는
        <br />
        <CountBox isInt={true}>1</CountBox>
        <Div>,</Div>
        <CountBox isInt={true}>3</CountBox>
        <CountBox isInt={true}>2</CountBox>
        <CountBox isInt={true}>7</CountBox>
        <CountBox isInt={false}>명</CountBox>
        입니다
      </MarginWrap2>
      <PcWrap>
        피플에 공유된 사연을 통해 사람들은
        <br /> 지속적으로 <span>헌혈문화</span>에<span> 유입</span> 되고
        있습니다.
      </PcWrap>
      <MbWrap>
        피플에 공유된 사연을 통해 <br />
        사람들은 지속적으로 <span>헌혈문화</span>에 <br />
        <span>유입</span>되고 있습니다.
      </MbWrap>
    </Container>
  );
};

const Container = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  font-family: 'NOTO';
  white-space: pre-wrap;
  > span {
    color: ${({ theme }) => theme.commonColor.pink005};
    font-size: 47px;
    font-style: normal;
    font-weight: 500;
    line-height: 65px;
    letter-spacing: -1.41px;
  }

  @media ${devices.tablet} {
    font-size: 24px;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
    > span {
      font-size: 24px;
      line-height: 36px;
      letter-spacing: -0.72px;
    }
  }
`;

const PcTitle = styled.div`
  display: block;

  @media ${devices.tablet} {
    display: none;
  }
`;

const MbTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: var(--Black, #222);
    text-align: center;
    font-family: 'NOTO';
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
  }
`;

const MarginWrap = styled.div``;
const MarginWrap2 = styled.div`
  margin-top: 50px;

  @media ${devices.tablet} {
    margin-top: 30px;
  }
`;

const CountBox = styled.div<{ isInt: boolean }>`
  padding: 3px 14px;
  background-color: ${({ theme, isInt }) =>
    isInt ? theme.commonColor.pink004 : '#FDD'};
  color: ${({ theme, isInt }) =>
    isInt ? theme.commonColor.white : theme.commonColor.pink005};
  display: inline-block;
  margin-top: 15px;
  &:not(first-child) {
    margin-right: 5px;
  }

  @media ${devices.tablet} {
    padding: 2px 6px;
  }
`;

const Div = styled.span`
  display: inline-block;
  padding: 3px 0;
`;

const PcWrap = styled.div`
  display: block;
  margin-top: 60px;
  color: var(--Black, #222);
  text-align: center;
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 153.846% */
  > span {
    color: var(--Pink-005, #ff4651);
  }
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbWrap = styled.div`
  display: none;

  @media ${devices.tablet} {
    display: block;
    color: var(--Black, #222);
    text-align: center;
    font-family: 'Var';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    margin-top: 30px;
    > span {
      color: var(--Pink-005, #ff4651);
    }
  }
`;

export default FourText;
